import React from 'react';

import './loading.css';

const Loading = ({ id }) => {
	return (
		<div className="loading" data-testid={id ? `loading-${id}` : 'loading-spinner'}>
			<i className="fa fa-spinner fa-spin" />
		</div>
	);
};

export default Loading;
